
/**
 * Constant names for service offering keys.
 * @type {Object}
 */
export const SERVICE_OFFERINGS = {
    homeEnergyPlan: 'home-energy-plan',
    financeOptions: 'finance-options',
    communityEnergyGroup: 'community-energy-group',
}

/**
 * Constant names for default notes.
 * @type {Object}
 */
export const DEFAULT_NOTES = {
    ownerOccupier: 'owner-occupier',
    plannedGroundExtension: 'planned-ground-extension',
    plannedLoftExtension: 'planned-loft-extension',
    heritage: 'heritage-property',
    woodenSashWindows: 'wooden-sash-windows',
    repairsNeeded: 'repairs-needed',
    repairDetails: 'repair-details',
    other: 'other-notes',
}

/**
 * Array of custom component names to automatically load. Inheriting
 * schemes can specify which of these they override.
 * @type {string[]}
 */
export const DEFAULT_COMPONENTS = [ 'cookie-consent-text' ]

/**
 * @type {Object}
 */
export const FEATURES = {
    SHOPPING_BASKET: 'shopping-basket',
}
